import { render, staticRenderFns } from "./InfoProcess.vue?vue&type=template&id=8ed3ec20&scoped=true&"
import script from "./InfoProcess.vue?vue&type=script&lang=js&"
export * from "./InfoProcess.vue?vue&type=script&lang=js&"
import style0 from "./InfoProcess.vue?vue&type=style&index=0&id=8ed3ec20&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed3ec20",
  null
  
)

export default component.exports